/**
 * Configuration shared by action components that must not depend on the plugin settings module.
 */
export const actionConfig = {
    /**
     * Determines whether settings requests should use message identifiers and action settings cache behavior.
     */
    useExperimentalMessageIdentifiers: false,
};
